import {NavLink} from "react-router-dom";
import './Home.css'
import {HelpAbility} from "helpers/HelpAbility";
import C from "helpers/HelpConstants";

const Home = () => {
    let myAbilities = HelpAbility();
    return (
        <div className="container">
            <div className="row no-gutters my-md-4">
                <div className="col-md-12 col-xs-12 ">
                    <h4 className="text-center" style={{color: '#009CDD'}}>Bienvenidos al Sistema de</h4>
                    <h2 className="text-center text-uppercase" style={{color: '#009CDD'}}>Administración de
                        Servicios</h2>
                    <div className="row">
                        {(myAbilities.has(C.A.SERVICE.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/services">
                                <div className="card card-custom">
                                    <img src="/img/service.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Servicios</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                        {(myAbilities.hasAnyStartedWith(C.A.PARAMETER.UPDATE) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/parameters">
                                <div className="card card-custom">
                                    <img src="/img/parameter.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Parámetros</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {/* {myAbilities.hasRol(C.R.DESARROLLADOR) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/datos-v8">
                                <div className="card card-custom">
                                    <img src="/img/v8.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Datos V8</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>} */}

                         { myAbilities.hasRol(C.R.DESARROLLADOR) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/datos">
                                <div className="card card-custom">
                                    <img src="/img/datos.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Datos</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE]) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/app-log">
                                <div className="card card-custom">
                                    <img src="/img/log-file.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">App Log</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {/* {(myAbilities.has(C.A.PRODUCT.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/products">
                                <div className="card card-custom">
                                    <img src="/img/product.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Productos</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                        {(myAbilities.has(C.A.CUSTOMER.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/clients">
                                <div className="card card-custom">
                                    <img src="/img/client.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Clientes</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                        {(myAbilities.has(C.A.LINE.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/lines">
                                <div className="card card-custom">
                                    <img src="/img/telephone-line.png"
                                         className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Lineas</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                        {(myAbilities.has(C.A.USER.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/users">
                                <div className="card card-custom">
                                    <img src="/img/user.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Usuarios</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                         {(myAbilities.has(C.A.DEPARTAMENT.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/departaments">
                                <div className="card card-custom">
                                    <img src="/img/departament.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Departamentos y Ciudades</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                         {(myAbilities.has(C.A.CENTER.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/centers">
                                <div className="card card-custom">
                                    <img src="/img/center.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Centros y Agentes</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>} */}

                        {/* {(myAbilities.has(C.A.PROCESSLOG.CREATE) && myAbilities.hasRol(C.R.SOPORTE)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/processlog">
                                <div className="card card-custom">
                                    <img src="/img/log-file.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Procesar Log</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.PROCESSLOG.LIST) && myAbilities.hasRol(C.R.SOPORTE)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/logs">
                                <div className="card card-custom">
                                    <img src="/img/log-files.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Ver Logs</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.PROCESSLOG.CREATE) && myAbilities.hasRol(C.R.SOPORTE)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/historial">
                                <div className="card card-custom">
                                    <img src="/img/historial.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Historial de Logs</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.ERROR.LIST) && myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE])) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/asignaciones">
                                <div className="card card-custom">
                                    <img src="/img/asignaciones.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Mis Asignaciones</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.FLUJO.LIST) && myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE])) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/flujos">
                                <div className="card card-custom">
                                    <img src="/img/flows.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Flujos de Estado</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.PROYECTO.LIST) && myAbilities.hasAnyRol([C.R.DESARROLLADOR, C.R.SOPORTE])) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/proyectos">
                                <div className="card card-custom">
                                    <img src="/img/proyectos.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Proyectos</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>} */}

                        {/* {(myAbilities.has(C.A.SERVICIOSHOGARPLANES.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/servicios-hogar-planes">
                                <div className="card card-custom">
                                    <img src="/img/servicioshogar.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Servicios Hogar Planes</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>} */}

                        {/* {(myAbilities.has(C.A.FLUJOSSTRUCTURE.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/flujos-estructure">
                                <div className="card card-custom">
                                    <img src="/img/flows.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Flujos Estructure</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.NIVELESSTRUCTURE.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/niveles">
                                <div className="card card-custom">
                                    <img src="/img/flows.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Niveles Estructure</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                         {(myAbilities.has(C.A.FLUJOSADDRESSCOMPLEMENT.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/flujos-address-complement">
                                <div className="card card-custom">
                                    <img src="/img/flows.png" className="card-img-top card-img-top-custom mx-auto"
                                         alt="..."/>
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Flujos Address Complement</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>} */}
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <p><strong>Objetivo Principal</strong></p>
                            <p>Consolidar conocimientos en ReactJs y NodeJs</p>
                            <p><strong>Objetivos Especificos</strong></p>
                            <ul>
                                <li>Gestionar los parámetros de los servicios registrados</li>
                                <li>Gestionar Permisos para la administración de servicios</li>
                            </ul>
                        </div>
                        {false && <div className="col-sm-6">
                            <p><strong>Próximamente...</strong></p>
                            <ul>
                                <li>Gestión de Clientes</li>
                                <li>Gestión de Lineas</li>
                                <li>Gestión de Permisos</li>
                            </ul>
                        </div>}
                    </div>
                </div>

                <div className="col-md-12 col-xs-12 ">
                    <div className="row">
                        <div className="col-sm-6">
                            <p className="text-center"><strong>Arquitectura Inicial</strong></p>
                            <img src="/img/AS-IS.PNG" className="img-fluid-noexiste" alt="Arquitectura Inicial"/>
                        </div>
                        <div className="col-sm-6">
                            <p className="text-center"><strong>Arquitectura Actual</strong></p>
                            <img src="/img/TO-BE.PNG" className="img-fluid-noexiste" alt="Arquitectura Actual"/>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    );
}
export default Home;